"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import { cn } from "@/src/utils/shadcn";

const activeClasses = cn("bg-primary text-white");

export function ModeToggle() {
  const { setTheme, theme } = useTheme();
  const [isMounted, setIsMounted] = React.useState(false);

  // Ensure the component is mounted on the client before applying dynamic classes
  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    // Return a fallback or an empty div to prevent SSR mismatch
    return <div className="fixed right-2 top-1/2 z-99"></div>;
  }

  return (
    <div className="fixed right-2 top-1/2 z-99">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div
            role="button"
            aria-label="theme switcher"
            aria-pressed={theme === "dark" ? "true" : "false"}
            className="grid h-12 w-12 cursor-pointer place-items-center rounded-5 bg-primary p-0 text-white hover:bg-primary-light"
          >
            {/* Sun Icon for Light Mode */}
            <Sun
              className={`h-[1.2rem] w-[1.2rem] transition-all ${
                theme === "dark" ? "rotate-0 scale-0" : "rotate-0 scale-100"
              }`}
            />
            {/* Moon Icon for Dark Mode */}
            <Moon
              className={`absolute top-4 right-4 h-[1.2rem] w-[1.2rem] transition-all ${
                theme === "light" ? "rotate-90 scale-0" : "rotate-0 scale-100"
              }`}
            />
            <span className="sr-only">Toggle theme</span>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="z-111 bg-white dark:border-accent-900 dark:bg-accent-700"
        >
          <DropdownMenuItem
            className={cn(theme === "light" && activeClasses)}
            onClick={() => setTheme("light")}
          >
            Light
          </DropdownMenuItem>
          <DropdownMenuItem
            className={cn(theme === "dark" && activeClasses)}
            onClick={() => setTheme("dark")}
          >
            Dark
          </DropdownMenuItem>
          <DropdownMenuItem
            className={cn(theme === "system" && activeClasses)}
            onClick={() => setTheme("system")}
          >
            System
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
